/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/users/login-1.scss";

export function AuthPage() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
          id="kt_login"
        >
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})`
            }}
          >
            <div className="d-flex flex-row-fluid flex-column justify-content-between ">
              <Link to="/" className="flex-column-auto mt-5">
                <img
                  alt="Logo"
                  className="max-h-70px"
                  src={toAbsoluteUrl("/media/logos/my-link-for-all-logo.png")}
                />
              </Link>
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">
                  Welcome to MyLinkForAll
                </h3>
                <p className="font-weight-lighter text-white opacity-80 "></p>
              </div>
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold text-white">
                  &copy; {new Date().getFullYear()} MyLinkForAll | Developed by{" "}
                  <a
                    href="https://whizpool.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-hover-primary"
                  >
                    Whizpool
                  </a>
                </div>
                <div className="d-flex">
                  <Link to="/privacy" className="text-white text-hover-primary opacity-80">
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Routes>
                <Route path="login" element={<ContentRoute component={Login} />} />
                <Route path="registration" element={<ContentRoute component={Registration} />} />
                <Route path="forgot-password" element={<ContentRoute component={ForgotPassword} />} />
                <Route index element={<Navigate to="/auth/login" replace />} />
                <Route path="*" element={<Navigate to="/auth/login" replace />} />
              </Routes>
            </div>
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; {new Date().getFullYear()} MyLinkForAll | Developed by{" "}
                <a
                  href="https://whizpool.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark-75 text-hover-primary"
                >
                  Whizpool
                </a>
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/privacy" className="text-dark-75 text-hover-primary">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
